import React, {useEffect, useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {useNavigate, useParams} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import FreeBox from "@/components/box/freeBox";
import {Button, Input} from "antd";
import TextArea from "antd/lib/input/TextArea";
import {DatePicker} from "antd-jalali";
import dayjs from "dayjs";
import {useApiGetTeacherHomeworks, useApiTeacherHomeworkCreate, useApiTeacherHomeworkUpdate} from "@/api/homework";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import RenderIf from "@/components/render-if";
import RenderLoading from "@/components/render-if-loading";

function TeacherHomeworkCreatePage(props) {
    const {id, homeworkId} = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        date: dayjs(new Date()).calendar("gregory").format("YYYY-MM-DD"),
    })

    const {mutate: createHomework, isPending} = useApiTeacherHomeworkCreate();
    const {mutate: updateHomework, isPending: isPendingUpdate} = useApiTeacherHomeworkUpdate();
    const {data: homeworkData, isPending: isPendingLoad} = useApiGetTeacherHomeworks({
        enabled: !!homeworkId,
        id: homeworkId
    })

    useEffect(() => {
        if (homeworkData?.data?.data) {
            setFormData(homeworkData.data?.data);
        }

    }, [homeworkId, homeworkData]);

    function saveData() {
        if (homeworkId) {
            updateHomework(
                {
                    ...formData,
                    id: homeworkId,
                },
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)

                    },
                    onError: (err) => {
                        ApiHandleErrorMessage(err)
                    }
                }
            )
        } else {
            createHomework(
                {
                    ...formData,
                    lesson_id: id
                },
                {
                    onSuccess: (res) => {
                        ApiHandleSuccessMessage(res)
                        navigate(sprintf(URLS.teacher.lessons.homeworks, {id: id}))
                    },
                    onError: (err) => {
                        ApiHandleErrorMessage(err)
                    }
                }
            )
        }

    }

    const pageTitle = homeworkId ? 'ویرایش تکلیف' : 'ثبت تکلیف جدید'

    return (
        <TeacherLayout pageTitle={pageTitle} backTo={sprintf(URLS.teacher.lessons.homeworks, {id: id})}>

            <FreeBox>
                <RenderLoading loading={homeworkId && isPendingLoad} skeleton={true}>
                    <div className={'mb-2'}>
                        <label className={'text-sm'}>
                            عنوان تکلیف
                            <Input size={'middle'} type={'text'} placeHolder={'عنوان تکلیف'}
                                   name={'title'}
                                   value={formData?.title}
                                   onChange={(e) => setFormData({...formData, [e.target.name]: e.target.value})}
                            />
                        </label>
                    </div>
                    <div className={'mb-2'}>
                        <label className={'text-sm'}>
                            جزئیات تکلیف
                            <Input.TextArea rows={5} size={'middle'}
                                      name={'description'}
                                      value={formData?.description}
                                      onChange={(e) => setFormData({...formData, [e.target.name]: e.target.value})}
                                      placeHolder={'جزئیات درخواست خود را برای دانش آموزان اینجا بنویسید'}>{formData?.description}</Input.TextArea>
                        </label>
                    </div>

                    <div className={'mb-2'}>
                        <label className={'text-sm'}>
                            مهلت انجام تکلیف
                            <DatePicker
                                className={'w-full'}
                                format="YYYY/MM/DD"
                                value={dayjs(formData?.date)?.calendar("jalali") ?? null}
                                onChange={(d) => setFormData({...formData, date: d?.calendar("gregory")})}
                                // onChange={(d) => setMyDate(d?.calendar("gregory"))}
                            />
                        </label>
                    </div>

                    <div className={'mb-2'}>
                        <label className={'text-sm'}>
                            امتیاز یا نمره این تکلیف
                            <Input size={'middle'}
                                   value={formData?.score}
                                   type={'number'} name={'score'} min={0}
                                   onChange={(e) => setFormData({...formData, [e.target.name]: e.target.value})}
                            />
                        </label>
                    </div>
                    <div className={'mb-2'}>
                        <div className="flex justify-between">
                            <div></div>
                            <div>
                                <Button
                                    loading={isPending}
                                    onClick={saveData}
                                    size={'middle'} color={'primary'} variant={'solid'}>
                                    <RenderIf condition={!!homeworkId} falsyElement={'ثبت و ارسال تکلیف'}>
                                        ویرایش تکلیف
                                    </RenderIf>

                                </Button>
                            </div>
                        </div>
                    </div>
                </RenderLoading>
            </FreeBox>
        </TeacherLayout>
    );
}

export default TeacherHomeworkCreatePage;